import type { StatementPostings } from "@/billing/types/statement-postings";

/** The postings of a statement nothing has been posted against. */
export const NO_STATEMENT_POSTINGS: Readonly<StatementPostings> = Object.freeze({
  payments: 0,
  adjustments: 0,
});
